import naja from "naja";

export default class SearchPlaceInput {
	constructor() {
		this.outputContainer = document.querySelector('div[data-provide="searchPlaceOutputContainer"]');
		this.init();
	}

	init() {
		const parent = this;

		document.querySelectorAll('input[data-provide="searchPlaceInput"]:not([data-spi-init="1"])').forEach(function (placeSearchInput, key) {
			placeSearchInput.setAttribute('data-spi-init', "1");

			// Vytvoření debounced funkce pro vyhledávání měst
			const debouncedSearchPlaces = global.debounce((value) => {
				naja.makeRequest("POST", placeSearchInput.getAttribute("data-handler"), {q: value}, {history: false}).then(results => {
					if (parent.outputContainer) {
						parent.outputContainer.innerHTML = "";

						if (!Array.isArray(results)) {
							return;
						}

						results.forEach((result) => {
							const a = document.createElement("a");
							a.classList.add("cityExample__item");
							a.href = "#";
							a.textContent = result;
							parent.outputContainer.appendChild(a);

							a.addEventListener("click", (e) => {
								// Bez toUpperCase() - hodnota jde do vyhledavani, kde se mesto/velkoobchod
								// porovnava proti nazvum v DB; verzalkami by se shoda ztratila.
								placeSearchInput.value = result;
								parent.outputContainer.innerHTML = "";
							});
						});
					}
				});
	 		}, 300);

			placeSearchInput.addEventListener("input", (e) => {
				debouncedSearchPlaces(e.target.value);
			});

			// Hide examples when clicking outside
			document.addEventListener('click', function(event) {
				if (!placeSearchInput.contains(event.target)) {
					parent.outputContainer.innerHTML = '';
				}
			});
		});
	}
}

